/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconFiletypeFolderPowerpoint = ({
  size = 16,
  className = '',
  ...props
}) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M10 4h2.74L10 1.26V4zm-.614 5.757c.231-.204.347-.493.347-.865 0-.27-.068-.5-.205-.693a.95.95 0 0 0-.538-.379c-.143-.038-.409-.057-.795-.057H6.547v2.303h1.665c.551 0 .942-.103 1.174-.309zm1.226-.891c0 .548-.175 1.011-.523 1.39-.349.38-.979.57-1.89.57H6.547v2.619h-.853V7.002h2.431c.427 0 .754.021.979.062.317.053.582.153.796.301s.385.355.516.622c.13.266.196.559.196.879zM14 15.557V5.001h-4c-.646 0-1-.438-1-1v-3H4a2 2 0 0 0-2 2v12.556c0 .245.198.443.443.443h11.114a.443.443 0 0 0 .443-.443z"
    />
  </svg>
);

IconFiletypeFolderPowerpoint.displayName = 'IconFiletypeFolderPowerpoint';

IconFiletypeFolderPowerpoint.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconFiletypeFolderPowerpoint);
IconFiletypeFolderPowerpoint.displayName = 'IconFiletypeFolderPowerpoint';
